import React, {useContext, useEffect} from 'react'
import FinancialTableRow from './FinancialTableRow'
import { UserSettingsContext } from '../../../context/UserSettingsContext';
import { currencyToSymbol } from '../../utils/commonUtils';

const IndustryDataSummary = ({ industryFinancialData, industryMarketData, setLoaded }) => {
    const { selectableAccounts } = useContext(UserSettingsContext);
    const unit = industryFinancialData && industryFinancialData.length > 0 ? currencyToSymbol(industryFinancialData[0].reported_currency) : ''

    // 特定のフィールドの有効なデータで平均値を計算する関数
    const averageOfField = (data, field) => {
        // 値がnullまたはundefinedでないデータをフィルタリング
        const validValues = data
            .map(item => item[field])
            .filter(value => value !== null && value !== undefined && !isNaN(value)); // NaNも除外
        if (validValues.length === 0) return null;
        const total = validValues.reduce((acc, value) => acc + value, 0);
        return (total / validValues.length)
    };
        
    const calcMedian = (data, field) => {
        // 値がnullまたはundefinedでないデータをフィルタリング
        const validValues = data
            .map(item => item[field])
            .filter(value => value !== null && value !== undefined && !isNaN(value)) // NaNも除外
            .sort((a, b) => a - b); // 昇順にソート
        if (validValues.length === 0) return null;
    
        const mid = Math.floor(validValues.length / 2);
    
        // 要素数が奇数なら中央の値、偶数なら中央の2つの値の平均を返す
        return validValues.length % 2 !== 0
            ? validValues[mid]
            : (validValues[mid - 1] + validValues[mid]) / 2;
    };
    
    useEffect(() => {
        setLoaded(true);
    }, [])

    return (
        <div className="dashboard-row h-[600px] max-h-screen">
            <h3 className='mb-1'>業界データ (中央値)</h3>
            <div className='mb-4 h-[530px] rounded-md overflow-y-auto'>
                <div className="financial-table ">
                    <div className="column">
                        <div className='header'>マーケット</div>
                        {selectableAccounts && industryMarketData && selectableAccounts.filter((account) => account.category_1.category === 'market')
                            .filter((account) => account.col !== 'stock_price')
                            .map((account) => (
                                <FinancialTableRow key={account.col} columnName={account.col_name} value={calcMedian(industryMarketData, account.col)} unit={account.unit === 'value' ? unit : account.unit} />
                            ))}
                        {/* <FinancialTableRow columnName="PER" value={calcMedian(industryFinancialData, 'per')} unit="倍" />
                        <FinancialTableRow columnName="PBR" value={null} unit="倍" />
                        <FinancialTableRow columnName="EPS" value={null} unit="円" /> */}
                    </div>
                    
                    <div className="column">
                        <div className="header">損益</div>
                        <div className="content">
                            {selectableAccounts && industryFinancialData && selectableAccounts.filter((account) => account.category_1.category === 'pl')
                            .map((account) => (
                                <FinancialTableRow key={account.col} columnName={account.col_name} value={calcMedian(industryFinancialData, account.col)} unit={account.unit === 'value' ? unit : account.unit} />
                            ))}
                            {/* <FinancialTableRow columnName="売上高" value={calcMedian(industryFinancialData, 'sales')} unit="円" />
                            <FinancialTableRow columnName="売上総利益" value={calcMedian(industryFinancialData, 'gross_profit')} unit="円" />
                            <FinancialTableRow columnName="営業利益" value={calcMedian(industryFinancialData, 'operating_income')} unit="円" />
                            <FinancialTableRow columnName="経常利益" value={calcMedian(industryFinancialData, 'ordinary_income')} unit="円" />
                            <FinancialTableRow columnName="当期利益" value={calcMedian(industryFinancialData, 'net_income')} unit="円" /> */}
                        </div>
                    </div>
                    <div className="column">
                        <div className="header">バランスシート</div>
                        <div className="content">
                            {selectableAccounts && industryFinancialData && selectableAccounts.filter((account) => account.category_1.category === 'bs')
                            .map((account) => (
                                <FinancialTableRow key={account.col} columnName={account.col_name} value={calcMedian(industryFinancialData, account.col)} unit={account.unit === 'value' ? unit : account.unit} />
                            ))}
                            
                            {/* <FinancialTableRow columnName="自己資本比率" value={calcMedian(industryFinancialData, 'equity_ratio')} unit="%" />
                            <FinancialTableRow columnName="流動比率" value={calcMedian(industryFinancialData, 'liquidity_ratio')} unit="%" />
                            <FinancialTableRow columnName="現預金比率" value={calcMedian(industryFinancialData, 'cash_deposit_ratio')} unit="%" />
                            <FinancialTableRow columnName="固定比率" value={calcMedian(industryFinancialData, 'fixed_ratio')} unit="%" />
                            <FinancialTableRow columnName="長期固定適合比率" value={calcMedian(industryFinancialData, 'long_term_fixed_fit_ratio')} unit="%" /> */}
                        </div>
                    </div>
                    <div className="column">
                        <div className="header">キャッシュフロー</div>
                        <div className="content">
                            {selectableAccounts && industryFinancialData && selectableAccounts.filter((account) => account.category_1.category === 'cf')
                            .map((account) => (
                                <FinancialTableRow key={account.col} columnName={account.col_name} value={calcMedian(industryFinancialData, account.col)} unit={account.unit === 'value' ? unit : account.unit} />
                            ))}
                        </div>
                    </div>
                    {/* <div className="column">
                        <div className="header">配当</div>
                        <div className="content">
                            <FinancialTableRow columnName="配当額" value={calcMedian(industryFinancialData, 'dividend')} unit="円" />
                            <FinancialTableRow columnName="配当性向" value={calcMedian(industryMarketData, 'dividend_ratio')} unit="%" />
                            <FinancialTableRow columnName="配当利回り" value={calcMedian(industryFinancialData, 'dividend_yield')} unit="%"/>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default IndustryDataSummary